import ButtonHoverlay from "./ButtonHoverlay";
import Loader from "../../assets/loading/loading.svg";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const Button = ({ text, stroke, link, color, text_color, loading }) => {
  return (
    <div className="button">
      <button
        className={`${loading ? "opacity-70" : ""} ${
          stroke
            ? "sys_primary border-2 sys_border_primary hover:border-0"
            : "sys_bg_primary text-white"
        } rounded font-semibold text-xl px-6 py-4 relative`}
        style={{
          backgroundColor: `${color ? color : ""}`,
          color: `${text ? text_color : ""}`,
        }}
      >
        {link && (
          <Link to={link}>
            {text}
            <ButtonHoverlay text={text} />
          </Link>
        )}
        {!link && (
          <div>
            {!loading ? text : <img className="w-6" src={Loader} />}
            <ButtonHoverlay text={text} loading={loading} />
          </div>
        )}
      </button>
    </div>
  );
};

Button.defaultProps = {
  loading: false,
};

Button.propTypes = {
  text: PropTypes.string,
  stroke: PropTypes.bool,
  link: PropTypes.string,
  color: PropTypes.string,
  text_color: PropTypes.string,
  active: PropTypes.bool,
  target: PropTypes.string,
  loading: PropTypes.bool,
};

export default Button;
